/**
 * Herkunft eines neuen Kontos (0219, SEO V5 28.10.2026): Seite des Klicks auf „Registrieren“ (?von=), Hostname der fremden Seite
 * davor (?ref=) und Kampagne aus der Adresse (utm_*). Die Registrierung per E-Mail gibt sie an signUp mit; bei „Mit Google
 * registrieren“ reist sie in der Rücksprung-Adresse mit und wird nach der Rückkehr ins Konto übernommen. Nichts davon wird im
 * Browser gespeichert (Linie G-010, Befund H-2 des Prüf-Chats).
 */
export interface Herkunft {
  von: string | null;
  ref: string | null;
  utm: { source: string | null; medium: string | null; campaign: string | null; content: string | null } | null;
}

const UTM = ["source", "medium", "campaign", "content"] as const;

/** Nur einfache Zeichen, je Wert höchstens 80 (Kampagne) bzw. 120/80 (Seite, Hostname); ohne Angaben null. */
export function herkunftAus(params: URLSearchParams): Herkunft {
  const wert = (k: string, max: number, re: RegExp) => { const v = (params.get(k) ?? "").replace(re, "").trim().slice(0, max); return v || null; };
  const u = Object.fromEntries(UTM.map((k) => [k, wert(`utm_${k}`, 80, /[^\p{L}\p{N} ._\-]/gu)])) as NonNullable<Herkunft["utm"]>;
  return {
    von: wert("von", 120, /[^A-Za-z0-9/_.\-]/g),
    // nur der Hostname: alles ab dem ersten fremden Zeichen fällt weg
    ref: (/^[A-Za-z0-9.-]+/.exec((params.get("ref") ?? "").trim())?.[0] ?? "").slice(0, 80) || null,
    utm: UTM.some((k) => u[k]) ? u : null,
  };
}

export function hatHerkunft(h: Herkunft): boolean {
  return !!(h.von || h.ref || h.utm);
}

/** Ziel nach der Rückkehr von Google mit der Herkunft als Adress-Parametern (die Supabase-Freigabe erlaubt /**). */
export function ruecksprungMitHerkunft(pfad: string, h: Herkunft): string {
  const q = new URLSearchParams();
  if (h.von) q.set("von", h.von);
  if (h.ref) q.set("ref", h.ref);
  for (const k of UTM) { const v = h.utm?.[k]; if (v) q.set(`utm_${k}`, v); }
  const s = q.toString();
  return s ? `${pfad}${pfad.includes("?") ? "&" : "?"}${s}` : pfad;
}
